import React from 'react';
import styles from '../TabShared.module.css';
import {getLabelTextMessage} from "../../../base/utils/GeneralUtilities";
import {LabelTextMessageTypes, type UserLanguages} from "../../../base/Settings";

interface VariableDropCellProps {
    user_language: UserLanguages;
    isRequiredMissing?: boolean;
    isLastRow?: boolean;
    minWidthPx?: number;
    colSpan?: number;
    onDrop: (e: React.DragEvent<HTMLTableCellElement>) => void;
    onDragOver?: (e: React.DragEvent<HTMLTableCellElement>) => void;
    children?: React.ReactNode;
}

/**
 * Shared drop zone cell for variables (or similar). Adds standardized styling for borders/hover/required.
 */
export const VariableDropCell: React.FC<VariableDropCellProps> = ({
                                                                      user_language,
                                                                      isRequiredMissing,
                                                                      isLastRow,
                                                                      minWidthPx = 120,
                                                                      colSpan,
                                                                      onDrop,
                                                                      onDragOver,
                                                                      children
                                                                  }) => {
    const hasChildren = React.Children.count(children) > 0;
    const placeholderText = isRequiredMissing
        ? getLabelTextMessage(LabelTextMessageTypes.VARIABLE_DROP_REQUIRED_PLACEHOLDER, user_language)
        : getLabelTextMessage(LabelTextMessageTypes.VARIABLE_DROP_OPTIONAL_PLACEHOLDER, user_language);
    const content = hasChildren ? children : <span className="text-muted">{placeholderText}</span>;

    return (
        <td
            colSpan={colSpan}
            onDrop={onDrop}
            onDragOver={onDragOver ?? ((e) => e.preventDefault())}
            className={[
                styles.cellCenter,
                styles.cellPadLg,
                styles.cellNoBorderBetweenCols,
                !hasChildren && !isRequiredMissing ? styles.dropCell : '',
                !isLastRow && !isRequiredMissing ? styles.cellBorderBottom : '',
                isRequiredMissing ? styles.dropCellRequired : ''
            ].filter(Boolean).join(' ')}
            style={{minWidth: `${minWidthPx}px`}}
        >
            {content}
        </td>
    );
};
